import { useEffect, useRef, useState } from "react";
import debounce from "../../../utils/functions/debounce";

export default function Accordion({ title, content }) {
  const [isOpen, setIsOpen] = useState(false);
  const [collapsedHeight, setCollapsedHeight] = useState(0);
  const headerRef = useRef(null);

  const handleResize = () => {
    if (headerRef.current) {
      const { height } = headerRef.current.getBoundingClientRect();
      setCollapsedHeight(Math.ceil(height));
    }
  };

  window.addEventListener("resize", handleResize);

  useEffect(() => {
    const resizeDebounced = debounce(handleResize, 150);
    resizeDebounced();
    window.addEventListener("resize", resizeDebounced);
    return () => window.removeEventListener("resize", resizeDebounced);
  }, []);

  return (
    <article
      className={`xpb-accordion ${isOpen ? "active" : ""}`}
      style={{ "--accordion-collapsed-height": `${collapsedHeight}px` }}
    >
      <div
        className="xpb-accordion__header"
        onClick={() => setIsOpen((prev) => !prev)}
        ref={headerRef}
      >
        {title}
        <button
          aria-label={isOpen ? "Más información" : "Cerrar"}
          className="xpb-accordion__btn"
        >
          <figure />
        </button>
      </div>
      <div className="xpb-accordion__content" aria-hidden={!isOpen}>
        {content}
      </div>
    </article>
  );
}
